module.exports = __webpack_public_path__ + "static/img/319_TO8_2486_og.6682ab6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/319_TO8_2486_og.jpg
// module id = n5XP
// module chunks = 0